/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_CountInputs */



/**
* | output |
* | --- |
* | "Tables" |
*
* @param {Rooms_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_count = /** @type {((inputs?: Rooms_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tables")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mesas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mesas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tavoli")
	return /** @type {LocalizedString} */ ("Tables")
});